const apiEndpointUrl = process.env.REACT_APP_API_BASE_URL?.trim();

if (!apiEndpointUrl) {
	throw new Error('REACT_APP_API_BASE_URL environment variable is required.');
}

export const env = {
	API_ENDPOINT_URL: apiEndpointUrl.replace(/\/+$/, '')
};
